<div class="alert alert-danger">
  <p>You have completed your quiz. Before continuing education credits can be granted, you must complete your profile.  Please click on the Complete Your Profile link below and fill in the required information.</p>
  <a class="btn-link text-underline text-primary" href="{{ profileUrl }}">Click Here to Complete Your Profile</a>
</div>
